window.addEventListener("load", function () {
  // if ($(window).width() > 999) {
  //   const video = document.getElementsByTagName("video")[0];
  //   const sources = video.getElementsByTagName("source");
  //   console.log(sources);
  //   const linkmp4 = $(sources).data("src");
  //   sources[0].src = linkmp4;
  //   video.load();
  // }

});
